import { isGradientType } from './isGradientType.js';

function getGradientFromColor(color) {
  return isGradientType(color) ? color : [{
    color,
    offset: 0
  }, {
    color,
    offset: 1
  }];
}

export { getGradientFromColor };
